/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERSKILLS= createAsyncThunk(
  "getUserSkills/getUserSkills",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserSkillsSlice = createSlice({
  name: "getUserSkillsSlice",
  initialState: {
    getUserSkills: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserSkills: (state) => {
        state.getUserSkills.loading = false
        state.getUserSkills.error = false
        state.getUserSkills.data = []
        state.getUserSkills.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERSKILLS.fulfilled, (state, action) => {
      state.getUserSkills = {
        ...state.getUserSkills,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSKILLS.pending, (state, action) => {
      state.getUserSkills = {
        ...state.getUserSkills,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSKILLS.rejected, (state, action) => {
      state.getUserSkills = {
        ...state.getUserSkills,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserSkillsAction = {
    GETUSERSKILLS,
};

export { getUserSkillsAction };
export default getUserSkillsSlice.reducer;
export const {setInitialStateOfgetUserSkills} = getUserSkillsSlice.actions